module.exports = __webpack_public_path__ + "static/media/elaf3.ee8ea8dc.webp";